import { siteCookieDomain } from '@/lib/attribution';

// Read by the API too, so a team browser's server events are tagged like its hits.
const INTERNAL_COOKIE = 'coretas_internal';
const MAX_AGE_SECONDS = 365 * 24 * 60 * 60;

export const internalCookie = ({
  hostname,
  protocol,
}: Pick<Location, 'hostname' | 'protocol'>): string => {
  const secure = protocol === 'https:' ? '; Secure' : '';
  return `${INTERNAL_COOKIE}=1; path=/${siteCookieDomain(hostname)}; max-age=${MAX_AGE_SECONDS}; SameSite=Lax${secure}`;
};

// Outlives sign-out, so a test signup on a team browser never counts as a customer.
export const markInternalDevice = (): void => {
  try {
    document.cookie = internalCookie(window.location);
  } catch {
    // A browser that blocks the cookie is tagged only while a team account is signed in.
  }
};

export const isInternalDevice = (): boolean => {
  try {
    return document.cookie.split('; ').includes(`${INTERNAL_COOKIE}=1`);
  } catch {
    return false;
  }
};
